module.exports = __webpack_public_path__ + "img/PrismNet_logo.df64e10c.png";